import { inject } from '@angular/core'
import { CanActivateFn, RedirectCommand, Router } from '@angular/router'

/**
 * Old links selected a row inside a list (`/premise/events?selectedId=…`); events, reservations and clients now have
 * their own pages. Redirects before the list renders, replacing the old URL so Back does not return to it.
 */
const legacySelectionGuard =
  (section: 'events' | 'reservations' | 'clients'): CanActivateFn =>
  (route) => {
    const selectedId = route.queryParamMap.get('selectedId')
    if (!selectedId) {
      return true
    }
    const router = inject(Router)
    return new RedirectCommand(router.createUrlTree(['/premise', section, selectedId]), { replaceUrl: true })
  }

export const eventsLegacySelectionGuard = legacySelectionGuard('events')
export const reservationsLegacySelectionGuard = legacySelectionGuard('reservations')
export const clientsLegacySelectionGuard = legacySelectionGuard('clients')
